<template>
    <div>
        <span class="label">{{ label }}</span>
        <v-text-field
            :color="color"
            v-model="model"
            :placeholder="placeholder"
            :rules="rules"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            hide-details
            clearable
            solo
            flat
            class="kimsa-elevation"
            @keydown.enter="$emit('enter')"
        ></v-text-field>
    </div>
</template>

<script>
export default {
    name: "KimsaPasswordField",
    props:{
        label:{
            type: String,
            default: '',
        },
        color:{
            type: String,
            default: 'secondary'
        },
        rules:{
            type: Array,
            default: []
        },
        placeholder:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            model: '',
            showPassword: false,
        }
    },
    watch:{
        model(val){
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

    .label{
        display: block;
        font-size: var(--fs-label);
        font-weight: 500;
        color: var(--v-txtSecondary-base);
        margin-bottom: 6px;
    }

</style>